import React, { useContext } from "react";
import NewMainLayout from "./NewMainlayout";
import MobileMainLayout from "./MobileMainLayout";
import useIsMobile, { MOBILE_BREAKPOINT } from "../../hooks/useIsMobile";
import { filtrationcontext } from "../../context/Filtercontext";
import Loader from "../Helpers/Loader/Loader";

const AdaptiveLayout = () => {
	const isMobile = useIsMobile(MOBILE_BREAKPOINT);
	const { loader } = useContext(filtrationcontext);
	if (loader)
		return (
			<div className="loader-container" style={{ height: "100vh" }}>
				<Loader />
			</div>
		);
	return isMobile ? <MobileMainLayout /> : <NewMainLayout />;
};

export default AdaptiveLayout;
